import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=ca48569e"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"
import style0 from "./Post.vue?vue&type=style&index=0&id=ca48569e&prod&lang=scss"
import style1 from "./Post.vue?vue&type=style&index=1&id=ca48569e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports